import { MenuItem } from './MenuItem';
import { useIntl } from 'react-intl';
import {toAbsoluteUrl} from '../../../helpers'


export function MenuInner() {

  const intl = useIntl();
  return (
    <>
      <img
          className='h-40px mr-10'
          src={toAbsoluteUrl('/media/logos/logo-literasi-satu-pintu-fix-white.png')}
          alt='metronic'
        />
      {/* <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard' /> */}
      {/* <MenuItem title='Backoffice Perpustakaan' onClick={handleBackOffice} to={''} /> */}
    </>
  );
}
